import usePaginatedLogList from "../../../../hooks/usePaginatedLogList";
import LogListError from "../../../../components/LogListError";
import React, { useEffect, useState } from "react";
import { Button, Table, Space, Tooltip, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { EyeOutlined } from "@ant-design/icons";
import moment from "moment";

const { Option } = Select;

const ListCompanyRefrigerationEquipLog = () => {
  const navigate = useNavigate();
  const { data, loading, load: loadRecords, pagination, error, retry } =
    usePaginatedLogList(ApiURL.company_refrigeration_equipment_log, "data");
  const [filter, setFilter] = useState("all");

  const [shipList, setShipList] = useState([]);
  const [shipId, setShipId] = useState("");

  const fetchShipTableList = async () => {
    const res = await post(ApiURL.list_ships_view_com, new FormData());
    if (res?.status && res.ships?.length) {
      setShipList(res.ships);
      setShipId(res.ships[0].id);
    }
  };

  const LIST_API = (selectedFilter = filter, selectedShip = shipId) => {
    if (!selectedShip) return;
    return loadRecords({ ship_id: selectedShip, ...(selectedFilter !== "all" ? { filter: selectedFilter } : {}) });
  };

  useEffect(() => {
    fetchShipTableList();
  }, []);

  useEffect(() => {
    if (shipId) LIST_API();
  }, [shipId]);

  const handleFilterChange = (value) => {
    setFilter(value);
    LIST_API(value, shipId);
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      align: "center",
      render: (date) => (date ? moment(date).format("DD-MM-YYYY") : "-"),
    },
    { title: "Added (kg)", dataIndex: "refrigerant_added_kgs", align: "center" },
    { title: "Initial Charge", dataIndex: "initial_system_charge", align: "center" },
    { title: "Recovered", dataIndex: "refrigerant_recovered", align: "center" },
    { title: "Leak Test", dataIndex: "leak_test_results", align: "center" },
    { title: "Auto Leak Detect", dataIndex: "auto_leak_detection_test", align: "center" },
    { title: "Remarks", dataIndex: "remarks_followup", align: "center" },
    {
      title: "Action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="View Record">
          <EyeOutlined
            style={{ fontSize: 18, color: "#1677ff", cursor: "pointer" }}
            onClick={() =>
              navigate(`/view-refrigeration-equip-log/${record?.id}`)
            }
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h2>Refrigeration Equip Log</h2>

        <Space>
          <Select
            value={shipId}
            style={{ width: 220 }}
            onChange={(value) => {
              setShipId(value);
            }}
          >
            {shipList.map((ship) => (
              <Option key={ship.id} value={ship.id}>
                {ship.vessel_name}
              </Option>
            ))}
          </Select>

          <Button type={filter === "all" ? "primary" : "default"} onClick={() => handleFilterChange("all")}>
            All
          </Button>
          <Button type={filter === "pending" ? "primary" : "default"} onClick={() => handleFilterChange("pending")}>
            Pending
          </Button>
          <Button type={filter === "approved" ? "primary" : "default"} onClick={() => handleFilterChange("approved")}>
            Approved
          </Button>

        </Space>
      </div>

      <LogListError error={error} retry={retry} />
      <Table
        pagination={pagination}
        bordered
        loading={loading}
        columns={columns}
        dataSource={data}
        rowKey="id"
        className="custom-table"
      />
    </>
  );
};

export default ListCompanyRefrigerationEquipLog;
